import moment from 'moment';
import { fromUnixTime } from 'date-fns';
import { format, utcToZonedTime } from 'date-fns-tz';
import { ReviewStatusEnum } from '@eisc-frontend/shared-ui';

const statusToPhase = (status: ReviewStatusEnum) => {
  const PreSubmission = [ReviewStatusEnum.Draft, ReviewStatusEnum.PreScreening];

  if (status === ReviewStatusEnum.Submitted) {
    return 'Submitted';
  }

  if (PreSubmission.includes(status)) {
    return 'Preliminary Screening';
  }

  if (status === ReviewStatusEnum.AwaitingProjectDescription) {
    return 'Awaiting Project Description';
  }

  if (status === ReviewStatusEnum.DescriptionComplete) {
    return 'Screening - Pending Comment Period';
  }

  if (status === ReviewStatusEnum.AwaitingComments) {
    return 'Awaiting Comments — Open for Commenting';
  }

  if (status === ReviewStatusEnum.ClosedForComments) {
    return 'Closed For Comments';
  }

  if (status === ReviewStatusEnum.Closed) {
    return 'Closed';
  }
};

export const serializeData = async (data) => {
  return data.map((item) => ({
    id: item.id,
    developer: item.developer?.name,
    title: item.title,
    publishedAt: item.publishedAt && moment.unix(item.publishedAt).format('YYYY-MM-DD'),
    createdAt:
      item.status !== ReviewStatusEnum.Draft &&
      item.createdAt &&
      moment.unix(item.createdAt).format('YYYY-MM-DD'),
    fileNumber: item.fileNumber,
    firstFieldWork:
      item.fieldworkSchedules?.length > 0
        ? moment(item.fieldworkSchedules[0].startDate).format('YYYY-MM-DD')
        : '-',
    status: item.status,
    phase: statusToPhase(item.status),
    related: [],
  }));
};

export const toEISCTime = (time: string, formatStr?: string): string => {
  const dateFormat = formatStr || 'MMM do, yyyy zzz';
  const formattedTime = format(
    utcToZonedTime(fromUnixTime(parseFloat(time)), process.env.GATSBY_DEFAULT_TIMEZONE),
    dateFormat,
  );
  return formattedTime;
};
